export default __webpack_public_path__ + "static/media/farming.1869c4c6.png";